import { Backdrop, CircularProgress } from "@mui/material";
import React from "react";

const BackdropLoader: React.FC<{ isOpen: boolean }> = ({ isOpen }) => {
  return (
    <>
      {isOpen ? (
        <Backdrop
          sx={{
            color: "#fff",
            zIndex: (theme) => theme.zIndex.drawer + 999,
          }}
          open={isOpen}
        >
          <CircularProgress />
        </Backdrop>
      ) : null}
    </>
  );
  
};

export default BackdropLoader;
